import httpClient from '../http-client'
import Comment from '../models/comment'
import CommentsForCreate from '../models/for-create/comments'
import CommentsForUpdate from '../models/for-update/comments'

const getComment = async (couponId: string) => {
	const comment = (await httpClient.get<Comment>(`comments/${couponId}`)).data

	return comment
}

const getAllComments = async (filters?: any) => {
	const comments = (await httpClient.get<any[]>('comments', { params: filters })).data
	if (comments && comments.length) {
		return comments
	}
}

const createComment = async (newCoupon: CommentsForCreate) => {
	const createCouponResponse = (await httpClient.post<any>(`comments/`, newCoupon)).data

	return createCouponResponse
}

const updateComment = async (couponId: any, newInfo: CommentsForUpdate) => {
	await httpClient.put(`comments/${couponId}`, newInfo)
}

const deleteComment = async (contentId: string) => {
	await httpClient.delete(`comments/${contentId}`)
}

export { getAllComments, deleteComment, updateComment, createComment, getComment }
